import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Downloads the uploaded ledger Excel file.
 * GET api/Onboarding/download-excel?filePath=...
 *
 * @param {string} filePath - filePath from upload-excel response
 * @param {string} fileName - original file name for the download
 */
export const downloadLedgerExcelAction = async (
  filePath,
  fileName = "ledger.xlsx",
) => {
  try {
    if (!filePath) return { success: false, error: "filePath is required" };

    const response = await apiClient.get(
      `${ATP_API_URL.DOWNLOAD_UPLOADED_FILE_LAGDER}?filePath=${encodeURIComponent(filePath)}`,
      { responseType: "blob" },
    );

    if (response?.status === 200 && response.data) {
      const url = URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(url);
      return { success: true };
    }
    return { success: false, error: "Download failed" };
  } catch (error) {
    return { success: false, error: error.message };
  }
};
